module.exports = __webpack_public_path__ + "./fonts/Changa-Bold.ttf";